import request from "../../../utils/request";

export const getCompanies = '/company/'

export function modifyCompany(data: any) {
    return request.request({
        url: '/company/',
        method: data.id ? 'put' : 'post',
        data: data
    })
}
